module.exports = __webpack_public_path__ + "media/bootstrap-icons/house-door-fill-86aeb0ba.svg";